export function LayoutSegment(_a) {
    var children = _a.children;
    return children || null;
}
